import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ENVIRONMENT } from '../../../../environments/environment';
import { Page } from '../../clients/interfaces/page.interface';

export interface DataViewClient {
  id: string;
  client_id: number;
  name: string;
  nip: number;
  sap_id: number;
  markets: Array<{ id: number; name: string }>;
  last_modification_date: string;
}

@Injectable()
export class DataViewClientsService {
  private baseUrl = ENVIRONMENT.engineUrl;

  constructor(private http: HttpClient) {}

  public getClientFromDataViewByClientId(clientId: number): Observable<DataViewClient> {
    return this.http
      .get<Page<DataViewClient>>(
        this.baseUrl +
          'api/data-view/all_clients' +
          '?filters=' +
          encodeURIComponent(
            JSON.stringify({
              filters: [
                {
                  column: 'client_id',
                  type: 'EQUALS',
                  value: clientId,
                },
              ],
            }),
          ),
      )
      .pipe(map((clientPage) => clientPage.content[0]));
  }
}



// WEBPACK FOOTER //
// ./src/modules/tasks/services/data-view-clients.service.ts